// Notifiche sul telefono, lato browser: permesso, iscrizione e casi particolari.
// Su iPhone funzionano solo con Wozzap aperta dalla schermata Home (iOS 16.4+).

export const supportate = () => typeof window !== 'undefined' && 'serviceWorker' in navigator
  && 'PushManager' in window && 'Notification' in window;

export const installata = () => window.matchMedia?.('(display-mode: standalone)')?.matches || window.navigator.standalone === true;

export const iPhoneDaSafari = () => /iPhone|iPad|iPod/.test(navigator.userAgent) && !installata();

export const permesso = () => (supportate() ? Notification.permission : 'unsupported');

// La chiave pubblica del server arriva in base64url: il browser la vuole in byte.
export function chiaveInByte(base64url) {
  const base64 = (base64url + '='.repeat((4 - (base64url.length % 4)) % 4)).replace(/-/g, '+').replace(/_/g, '/');
  return Uint8Array.from(atob(base64), c => c.charCodeAt(0));
}

export function nomeDispositivo(ua = navigator.userAgent) {
  const sistema = /iPhone/.test(ua) ? 'iPhone' : /iPad/.test(ua) ? 'iPad' : /Android/.test(ua) ? 'Android'
    : /Mac OS X/.test(ua) ? 'Mac' : /Windows/.test(ua) ? 'Windows' : 'Dispositivo';
  const browser = /Edg\//.test(ua) ? 'Edge' : /Firefox\//.test(ua) ? 'Firefox' : /Chrome\//.test(ua) ? 'Chrome'
    : /Safari\//.test(ua) ? (installata() ? 'app' : 'Safari') : '';
  return browser ? `${sistema} · ${browser}` : sistema;
}

async function registrazione() {
  // In produzione la registra index.js; qui si aspetta che sia pronta (o la si registra).
  const esistente = await navigator.serviceWorker.getRegistration();
  if (!esistente) await navigator.serviceWorker.register('/sw.js');
  return navigator.serviceWorker.ready;
}

export async function iscrizioneAttuale() {
  if (!supportate()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
}

// Va chiamata da un tocco: Safari chiede il permesso solo così.
export async function attiva(chiavePubblica) {
  const scelta = await Notification.requestPermission();
  if (scelta !== 'granted') throw Object.assign(new Error('permesso negato'), { codice: scelta });
  const reg = await registrazione();
  const vecchia = await reg.pushManager.getSubscription();
  const iscrizione = vecchia || await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: chiaveInByte(chiavePubblica) });
  return iscrizione.toJSON();
}

export async function disattiva() {
  const iscrizione = await iscrizioneAttuale();
  if (!iscrizione) return '';
  const { endpoint } = iscrizione;
  await iscrizione.unsubscribe();
  return endpoint;
}
